/**
 * Parse an Ari match card id into an external_jobs primary key.
 * Accepts `fj-{external_jobs.id}` or a bare positive integer.
 * Rejects live Fantastic.jobs ids (`fj-live-…`) that are not in external_jobs.
 * @param {string|number|null|undefined} id
 * @returns {number|null}
 */
export function parseAriJobId(id) {
  if (id == null || id === '') {
    return null;
  }
  const raw = String(id);
  if (/^fj-live-/i.test(raw)) {
    return null;
  }
  const numeric = raw.replace(/^fj-/i, '');
  const n = Number(numeric);
  if (!Number.isFinite(n) || n <= 0) {
    return null;
  }
  return n;
}

/**
 * Parse an Ari Twine card id (`twine-{collaboration_notices.id}`) into a job id.
 * @param {string|number|null|undefined} id
 * @returns {number|null}
 */
export function parseTwineJobId(id) {
  const match = /^twine-(\d+)$/i.exec(String(id == null ? '' : id));
  return match ? Number(match[1]) : null;
}

/**
 * Build POST /job-tracker/entries body from a Twine job id and/or Ari job id.
 * Prefer Twine job_id when both are present.
 * @param {{ jobId?: number|string|null, ariJobId?: number|string|null }} opts
 * @returns {{ job_id: number|string }|{ ari_job_id: number }|null}
 */
export function buildSaveJobBody({ jobId, ariJobId } = {}) {
  if (jobId != null && jobId !== '') {
    return { job_id: jobId };
  }
  const parsed = parseAriJobId(ariJobId);
  if (parsed != null) {
    return { ari_job_id: parsed };
  }
  return null;
}
